import { AlertCircle, CheckCircle2 } from 'lucide-react';
import { cn } from '../../lib/utils';

interface PreviewHeaderProps {
  isValid: boolean;
}

export function PreviewHeader({ isValid }: PreviewHeaderProps) {
  return (
    <div className="p-6 border-b bg-card flex justify-between items-center">
      <div>
        <h2 className="text-xl font-bold tracking-tight">Form Preview & Debugger</h2>
        <p className="text-xs text-muted-foreground mt-1">
          Simulate real-world usage and inspect technical state.
        </p>
      </div>
      <div
        className={cn(
          'flex items-center gap-2 px-3 py-1.5 rounded-full text-[10px] font-bold uppercase tracking-wider transition-colors',
          isValid
            ? 'bg-green-500/10 text-green-600 border border-green-500/20'
            : 'bg-amber-500/10 text-amber-600 border border-amber-500/20'
        )}
      >
        {isValid ? <CheckCircle2 className="w-3 h-3" /> : <AlertCircle className="w-3 h-3" />}
        {isValid ? 'Form Valid' : 'Form Invalid'}
      </div>
    </div>
  );
}
